<div class="d-flex justify-content-between mb-46 align-items-center">
  <figure class="m-0 p-0 cursor-pointer"><img (click)="switchTab('vehicleslist')" src="assets/images/auth_images/safeignite_logo.svg" alt="" width="100%" height="100%"></figure>
  <div
    class="tab-container d-inline-flex color-graylight  justify-content-center align-items-center active line-height-24 fs-18 ff-Sarabun text-center gap-32  cursor-pointer">
    <div class="fw-600 " [class.active]="isActive('overview')" (click)="switchTab('overview')">
      {{ 'HEADER.OVERVIEW' | translate }}
    </div>
    <div class="fw-600 " [class.active]="isActive('vehicleslist')" (click)="switchTab('vehicleslist')">
     {{ 'HEADER.ALL_VEHICLES' | translate }}
    </div>
  </div>
<div class=" d-flex justify-content-end">
  <div class="d-flex justify-content-end" style="width:140px">
    <div class="w-80 h-80 bg-azureblue border-radius-50 d-flex align-items-center justify-content-center">
      <span [routerLink]="['dashboard/profile']"
            class="fs-16 color-white ff-Sarabun fw-700 cursor-pointer">
        {{ initials || 'U' }}
      </span>
    </div>
  </div>
</div>

</div>
